// Named z-index tiers for v3. Every `z-index` in the app should map to
// one of these constants; do NOT write magic numbers or bump values on
// the spot. Adding a new consumer? Pick the tier that fits its
// interaction role, or file an issue if none does.
//
// Layer manager (reserved ranges):
//   0    – 999   normal page / static chrome
//   1000 – 1999  in-flow floating (dropdown / sticky / banner)
//   2000 – 2499  Legacy Reserved — Element UI 2.x PopupManager
//                increments from 2000 on each opened popup; the buffer
//                keeps host overlays untouched under heavy stacking.
//   2500 – 2999  Host overlays (modal / drawer / popover / tooltip)
//   3000+        Element Plus runtime (ElMessage / ElDialog / ElPopover)
//                pool. Configured via ElConfigProvider `:z-index="3000"`
//                in main.ts. NEVER write `z-index: 3xxx` manually —
//                collides with EP's per-popup counter.
//   10000        a11y skip-link — above realistic EP counter growth.
export const Z = {
  base: 0,
  chrome: 100,

  dropdown: 1000,
  sticky: 1100,
  banner: 1200,

  legacy: 2000,

  overlay: 2500,
  drawer: 2600,
  modal: 2700,
  popover: 2800,
  tooltip: 2900,

  skipLink: 10000,
} as const;

// Element Plus popup pool base — mirrors the reserved range above so
// consumers wiring `ElConfigProvider :z-index` point at the same value.
export const EP_ZINDEX_BASE = 3000;
